import React, { useState, useEffect, useCallback, Fragment } from 'react';
// import moment from 'moment';
import { Modal, ModalBody } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faHotel, faUserAlt, faPhone, faHourglassStart, faHourglassEnd, faClipboard, faFlag,
//   faDoorClosed, faPlus, faMinus, faSave, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
  // import countryInfo from '../../../assets/countries.json';
import { ResponseSuccessModal, ResponseFailModal } from '../../modal/Response';
import * as api from '../../../api';

const BookingDetail = ({
  isOpen,
  toggle,
  reload,
  bookingId,
}) => {
  // const [ isOpenBookingCancelModal, setIsOpenBookingCancelModal ] = useState(false);
  const [ isOpenBookingUpdateSuccessModal, setIsOpenBookingUpdateSuccessModal ] = useState(false);
  const [ isOpenBookingUpdateFailModal, setIsOpenBookingUpdateFailModal ] = useState(false);
  // const countryInfoList = Object.values(countryInfo);
  // const [ countryNumber, setCountryNumber ] = useState('82');
  // const [ buildingItems, setBuildingItems ] = useState([]);
  // const [ roomItems, setRoomItems ] = useState([]);
  const [ selectedBuildingId, setSelectedBuildingId ] = useState('');
  // const [ selectedRoomId, setSelectedRoomId ] = useState('');
  const [ activeTab, setActiveTab ] = useState(1);
  const [ bookingSelectItem, setBookingSelectItem ] = useState({
    buildingName: '',
    roomName: '',
    userName: '',
    phoneNumber: '',
    desc: '',
    checkinAt: '',
    checkoutAt: '',
    createdAt: '',
    updatedAt: '',
  });
  // const [ userkeyListItems, setUserkeyListItems ] = useState([]);

  const selectBooking = useCallback(async () => {
    try {
      const res = await api.selectBooking({bookingId});
      setBookingSelectItem({
        buildingName: res.data.building.name,
        roomName: res.data.room.name,
        userName: res.data.user.name,
        phoneNumber: res.data.user.phone_number ? res.data.user.phone_number.replace(/([0-9]*)(\d{10})/, '0$2'):'',
        desc: res.data.desc || '',
        checkinAt: new Date(res.data.checkin_at),
        checkoutAt: new Date(res.data.checkout_at),
        createdAt: res.data.created_at,
        updatedAt: res.data.updated_at,
      });
      // setUserkeyListItems([...res.data.pincodes, ...res.data.mobilekeys]);
      setSelectedBuildingId(res.data.building.id);
      // setSelectedRoomId(res.data.room.id);
      // if (res.data.user.phone_number) setCountryNumber(res.data.user.phone_number.replace(/([0-9]*)(\d{10})/, '$1'));
    } catch (error) {
      throw error;
    }
  }, [bookingId]);

  // const updateBooking = async () => {
  //   try {
  //     const reqNum = countryNumber + Number.parseInt(bookingSelectItem.phoneNumber);
  //     await api.updateBooking({bookingId, ...bookingSelectItem, phoneNumber:reqNum});
  //   } catch (error) {
  //     throw error;
  //   }
  // };

  useEffect(() => {
    const listRoom = async () => {
      try {
        // const res = await api.listRoom({buildingId: selectedBuildingId});
        // setRoomItems(res.data.items);
      } catch (error) {
        throw error;
      }
    };
    if (selectedBuildingId) listRoom();
  }, [selectedBuildingId]);

  useEffect(() => {
    const listBuilding = async () => {
      try {
        // const res = await api.listBuilding({});
        // setBuildingItems(res.data.items);
      } catch (error) {
        throw error;
      }
    };
    listBuilding();
  }, []);

  useEffect(() => {
    if (bookingId) selectBooking();
  }, [bookingId, selectBooking]);

  return (
    <Fragment>
      <Modal
        show={isOpen}
        onHide={() => toggle()}
        centered
        backdrop='static'
        size='md'
      >
        <ModalBody className='m-3' style={{margin:0, padding:0, backgroundColor:'#282C34'}}>
          <div className='form-card'>
            <div className='form-card-title'>
              <h4>{bookingSelectItem.roomName || '101'}<span>({bookingSelectItem.buildingName || 'A동'})</span></h4>
            </div>
            <div className='form-tab modal-detail'>
              <p className={`tab-item ${activeTab !== 1 ? 'inactive':''}`} onClick={() => setActiveTab(1)}>예약정보</p>
              <p className={`tab-item ${activeTab !== 2 ? 'inactive':''}`} onClick={() => setActiveTab(2)}>키정보</p>
            </div>
            <div hidden={activeTab !== 1}>
              <div className='inline-flex tab'>
                <div className='w-100'>
                  <div className='card-text'>
                    <p>
                      {/* <FontAwesomeIcon icon={faUserAlt}/> */}
                      <b>예약자명</b>
                      {/* <span className='required'>*</span> */}
                    </p>
                    <input
                      className='card-text-input bb-unset'
                      placeholder='예약자명을 입력 해주세요.'
                      value={bookingSelectItem.userName || '홍길동'}
                      disabled
                      // onChange={e => setBookingSelectItem({...bookingSelectItem, userName:e.target.value})}
                    />
                  </div>
                  <div className='card-text'>
                    <p>
                      {/* <FontAwesomeIcon icon={faPhone}/> */}
                      <b>전화번호</b>
                      {/* <span className='required'>*</span> */}
                    </p>
                    {/* <select
                      className='card-text-select bb-unset'
                      value={countryNumber}
                      onChange={e => setCountryNumber(e.target.value)}
                      disabled
                    >
                      {countryInfoList.map((country, index) => (
                        <option key={`country-index-${index}`} value={country.phone}>{`${country.name} ( +${country.phone} )`}</option>
                      ))}
                    </select>
                    <p></p> */}
                    <input
                      className='card-text-input bb-unset'
                      placeholder='전화번호를 입력 해주세요.'
                      value={bookingSelectItem.phoneNumber || '821012345678'}
                      maxLength='11'
                      disabled
                      // onChange={e => setBookingSelectItem({...bookingSelectItem, phoneNumber:e.target.value})}
                    />
                  </div>
                  <div className='card-text'>
                    <p>
                      {/* <FontAwesomeIcon icon={faHourglassStart}/> */}
                      <b>체크인 날짜</b>
                      {/* <span className='required'>*</span> */}
                    </p>
                    <DatePicker
                      className='bb-unset'
                      dateFormat='yyyy-MM-dd HH:mm'
                      placeholderText='체크인 날짜를 선택 해주세요.'
                      selected={bookingSelectItem.checkinAt}
                      selectsStart
                      minDate={new Date()}
                      endDate={bookingSelectItem.checkoutAt}
                      showTimeSelect
                      timeFormat='HH:mm'
                      timeIntervals={60}
                      timeCaption='Time'
                      onChange={date => setBookingSelectItem({...bookingSelectItem, checkinAt:date})}
                      withPortal
                      disabled
                    />
                  </div>
                  <div className='card-text'>
                    <p>
                      {/* <FontAwesomeIcon icon={faHourglassEnd}/> */}
                      <b>체크아웃 날짜</b>
                      {/* <span className='required'>*</span> */}
                    </p>
                    <DatePicker
                      className='bb-unset'
                      disabled={!bookingSelectItem.checkinAt}
                      dateFormat='yyyy-MM-dd HH:mm'
                      placeholderText='체크아웃 날짜를 선택 해주세요.'
                      selected={bookingSelectItem.checkoutAt}
                      selectsEnd
                      minDate={bookingSelectItem.checkinAt}
                      startDate={bookingSelectItem.checkinAt}
                      showTimeSelect
                      timeFormat='HH:mm'
                      timeIntervals={60}
                      timeCaption='Time'
                      onChange={date => setBookingSelectItem({...bookingSelectItem, checkoutAt:date})}
                      withPortal
                    />
                  </div>
                  <div className='card-text'>
                    <p>
                      {/* <FontAwesomeIcon icon={faClipboard}/> */}
                      <b>비고</b>
                    </p>
                    <input
                      className='card-text-input bb-unset'
                      placeholder='예약에 대한 설명을 입력 해주세요.'
                      value={bookingSelectItem.desc}
                      onChange={e => setBookingSelectItem({...bookingSelectItem, desc:e.target.value})}
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div className='card-foot' style={{paddingLeft:'1.8rem'}}>
                {/* <div className='form-item-cancel'>
                  <button className='btn-item-cancel' onClick={() => toggle()}>
                    <FontAwesomeIcon icon={faTimesCircle} style={{paddingRight:'3px'}}/><span>취소</span>
                  </button>
                </div>
                <div className='form-item-add center'>
                  <button className='btn-item-add' onClick={updateBooking}>
                    <FontAwesomeIcon icon={faSave} style={{paddingRight:'2px'}}/><span>저장</span>
                  </button>
                </div> */}
              </div>
            </div>
            <div hidden={activeTab !== 2}>
              <div className='inline-flex tab'>
                <div className='w-100 excel-desc'>
                  <p>Excel 파일 업로드를 통해서 단지뿐만 아니라 여러 빌딩, 층, 객실까지 한번에 생성 가능</p>
                  <p>
                    * Excel 파일 업로드 규칙<br></br>
                    1. 1개의 파일만 가능하며, 1개의 sheet만 가능.<br></br>
                    2. sheet의 이름을 'sheet1'로 작성하고<br></br>
                    3. 1행 A열 부터<br></br>
                    4. 단지 이름(필수), 빌딩 이름(필수), 층 이름, 방 이름(필수), RMS ID 순으로 작성.<br></br>
                    단, 셀 서식이 '텍스트'여야 함.<br></br>
                  </p>
                  <p>
                    예:<br></br>
                    ABC Hotel, A동, 1F, 101호, 000001 (O)<br></br>
                    ABC Hotel, A동, '', 102호, '' (O)<br></br>
                    ABC Hotel, '', 1F, 103호, 000002 (X)<br></br>
                  </p>
                </div>
              </div>
              <div className='card-foot' style={{paddingLeft:'1.8rem'}}>

              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <ResponseSuccessModal
        isOpen={isOpenBookingUpdateSuccessModal}
        toggle={() => setIsOpenBookingUpdateSuccessModal(!isOpenBookingUpdateSuccessModal)}
        message='Booking information change success.'
      />
      <ResponseFailModal
        isOpen={isOpenBookingUpdateFailModal}
        toggle={() => setIsOpenBookingUpdateFailModal(!isOpenBookingUpdateFailModal)}
        message='Booking information change fail.'
      />
    </Fragment>
  );
};

export default BookingDetail;